export const createNewsletterSubscriptionRequests = (client) => ({
    createNewsletterSubscription: async (payload) => {
        const { data } = await client.api.create("newsletter-subscriptions", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map